import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { AssetEventType, GenericExternalSystemType } from "../../api/assetEvent";
import { ExternalSystem } from "../../api/externalSystemRequest";

export const PaymentExternalSystems : ExternalSystem[] = [
    {
        title: 'Send for Reconciliation',
        description: 'Send your Payment to InMatch so that it can be automatically matched',
        icon: '/assets/images/inblock_logo_white.png',
        type: 'inblock',
        assetEventType: AssetEventType.ingested_inmatch,
        externalSystemType: GenericExternalSystemType.inblock,
        failMessage: 'Failed to send for Reconciliation',
        globalFailMessage: 'Payment(s) received an error when sending for Reconciliation',
        successMessage: 'Sent for Reconciliation',
        globalSuccessMessage: 'Payment(s) were successfully sent for Reconciliation',
        waitingMessage: 'Waiting for Reconciliation',
        requiredPermission: UserEntitlementCatalogs.SendForReconciliation
    }
];
